import React from 'react';
import ReactDOM from 'react-dom/client';
// import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "./assets/css/myCustomTheme.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "jquery/dist/jquery.min.js";
import "./assets/css/oldStyle.css";
// import "../public/assets/css/mainStyle.css";

// import App from './App';
import Home from './pages/Home';
import HomeEn from './pages/International';
import About from './pages/About';
import Activity from './pages/News';
import { ApiGetTest } from './comp_ict/api_axios';
// import Activities from "./components/activities";
import Staff from "./pages/staff";
import Calendars from './pages/calendar';
import DeanDm, { DeanDmTrackingForm, DeanDmTracking } from './pages/DeanDm';
import Testing from './pages/test/test';
import ApiGenerator from './api_gen/ApiGenerator';
import UnderConstruction from './components/underConstruction';
import Researcher from './pages/Researcher';
import ResearchBudget from './pages/ResearchBudget';


const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "en",
    element: <HomeEn />,
  },
  {
    path: "/about/",
    element: <About/>,
  },
  {
    path: "/about/:page",
    element: <About/>,
  },
  // {
  //   path: "news",
  //   element: <Activity />,
  // },
  {
    path: "/news/:code",
    element: <Activity />,
  },
  {
    path: "/person/:page",
    element: <Staff />,
  },
  {
    path: "/calendar/:id",
    element: <Calendars />,
  },
  {
    path: "/deanDm",
    element: <DeanDm />,
  },
  {
    path: "/deanDm/tracking",
    element: <DeanDmTrackingForm />,
  },
  {
    path: "/deanDm/tracking/:DmToken",
    element: <DeanDmTracking />,
  },
  {
    path: "/api",
    element: <ApiGetTest apiUrl="https://aed.mju.ac.th/api/arch/partners/" dataName="partnerBanner" />,
  },
  {
    path: "/test",
    element: <Testing />,
  },
  {
    path: "/_admin/apigen/staff",
    element: <ApiGenerator />,
  },
  {
    path: "/_admin/apigen/staff/:jsonfile",
    element: <ApiGenerator />,
  },
  {
    path: "/researcher",
    element: <Researcher />,
  },
  {
    path: "/researchbudget/:year_params?",
    element: <ResearchBudget />,
  },
  {
    path: "/under_construction",
    element: <UnderConstruction />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <RouterProvider router={router} />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(); 
